const SEARCH_RESULTS_NOT_PRESENT = null;

export default SEARCH_RESULTS_NOT_PRESENT;
